import type {
  RegisterFormFieldSchema,
  ResetPasswordResetPayload,
} from '@/schemas/auth'
import type { LoginFormValues, PostAuthRegisterResponse } from '@/types/auth'
import { cookie } from '@/utils/cookie'
import { httpClient, httpClientHeaderMac } from '@/utils/http'

export const authService = {
  get accessToken() {
    return cookie.get('act') ?? null
  },
  set accessToken(token: string | null) {
    token
      ? cookie.set('act', token, {
          expires: 7,
        })
      : cookie.remove('act')
  },
  get refreshToken() {
    return cookie.get('rft') ?? null
  },
  set refreshToken(token: string | null) {
    token
      ? cookie.set('rft', token, {
          expires: 30, // 30 days
        })
      : cookie.remove('rft')
  },
  get isAuthenticated() {
    return !!this.accessToken && !!this.refreshToken
  },
  login: (payload: Omit<LoginFormValues, 'rememberMe'>) =>
    httpClientHeaderMac.post('sessions', {
      json: payload,
    }),
  logout: () => httpClientHeaderMac.delete('sign_out'),
  register: (payload: RegisterFormFieldSchema) =>
    httpClientHeaderMac
      .post('registrations', {
        json: payload,
      })
      .json<PostAuthRegisterResponse>(),
  resetPassword: (payload: Record<'email', string>) =>
    httpClient.post('reset_passwords', { json: payload }),
  verifyResetPassword: (payload: Record<'token', string>) =>
    httpClientHeaderMac.put('reset_passwords', { json: payload }),
  doResetPassword: (payload: ResetPasswordResetPayload) =>
    httpClient.post('reset_passwords/reset', { json: payload }),
}
